import { BadgeCheck, Quote } from "lucide-react";
import { FadeUp, Eyebrow } from "./Reveal";

const TESTIMONIALS = [
  {
    name: "Marcus Hale",
    age: "Busy Dad of Three",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80",
    quote: "I kept skipping the gym because I never had a free hour. Now I crush a 20-minute builder before the kids wake up — six weeks without a missed day.",
    metric: "42-Day Streak",
  },
  {
    name: "Elena Ruiz",
    age: "Consultant, Lives On Planes",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80",
    quote: "Hotel room, 10 minutes before boarding — Fit50 still gives me a real, structured workout. It's the first program that survived my travel schedule.",
    metric: "312 Sessions This Year",
  },
  {
    name: "David Okafor",
    age: "Executive, Zero Time",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80",
    quote: "Some days it's 10 minutes, some days 50 — the app builds both to the same standard. Eleven pounds of muscle without ever blocking my calendar.",
    metric: "+11 lbs Lean Mass",
  },
];

export const Testimonials = () => (
  <section id="results" data-testid="testimonials-section" className="relative py-32 scroll-mt-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <FadeUp>
        <Eyebrow>Member Proof</Eyebrow>
        <h2 className="font-display font-extrabold uppercase tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl mt-4 max-w-3xl">
          Results from people who <span className="text-volt">never had the time</span>
        </h2>
      </FadeUp>

      <div className="mt-16 grid md:grid-cols-3 gap-4">
        {TESTIMONIALS.map((t, i) => (
          <FadeUp key={t.name} delay={i * 0.1}>
            <figure
              data-testid={`testimonial-card-${i + 1}`}
              className="group h-full border border-white/10 bg-carbon p-8 flex flex-col hover:border-volt/40 hover:-translate-y-1 transition-[border-color,transform] duration-300"
            >
              <Quote className="h-6 w-6 text-volt" />
              <blockquote className="mt-5 text-base text-neutral-300 leading-relaxed flex-1">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <div className="mt-6 inline-flex w-fit bg-volt px-3 py-1.5 font-mono text-[11px] tracking-widest uppercase text-white">
                {t.metric}
              </div>
              <figcaption className="mt-6 pt-6 border-t border-white/10 flex items-center gap-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  loading="lazy"
                  className="h-12 w-12 rounded-full object-cover border border-white/20 grayscale group-hover:grayscale-0 transition-[filter] duration-300"
                />
                <div>
                  <p className="font-display font-bold uppercase tracking-wide flex items-center gap-1.5">
                    {t.name}
                    <BadgeCheck className="h-4 w-4 text-volt" />
                  </p>
                  <p className="font-mono text-[10px] tracking-widest uppercase text-neutral-500 mt-0.5">{t.age}</p>
                </div>
              </figcaption>
            </figure>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
